function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "BCC809D9-FCAA-4BD5-9E68-0B2A8177D49A@1.00x");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 417,
  height: 284,
  rx: 5
}), React.createElement("filter", {
  x: "-6.1%",
  y: "-7.9%",
  width: "112.2%",
  height: "118.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feMorphology", {
  radius: 1,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 3,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 7,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMorphology", {
  radius: 0.5,
  operator: "dilate",
  in: "SourceAlpha",
  result: "shadowSpreadOuter2"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 8,
  in: "shadowSpreadOuter2",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMorphology", {
  radius: 1.5,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadOuter3"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 5,
  in: "shadowSpreadOuter3",
  result: "shadowOffsetOuter3"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter3",
  result: "shadowBlurOuter3"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
  type: "matrix",
  in: "shadowBlurOuter3",
  result: "shadowMatrixOuter3"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter3"
}))));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "2.1-Course-details",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Notification---nonGraded-attendance",
  transform: "translate(-46.000000, -86.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(10.000000, 11.000000)"
}, React.createElement("g", {
  id: "Group-7"
}, React.createElement("g", {
  id: "Rectangle"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), React.createElement("path", {
  d: "M108.35903,86.3684786 C108.837738,85.8771738 109.613875,85.8771738 110.092583,86.3684786 L110.092583,86.3684786 L145.64097,122.85235 C146.119677,123.343654 146.119677,124.140217 145.64097,124.631521 C145.162262,125.122826 144.386125,125.122826 143.907417,124.631521 L143.907417,124.631521 L137.506905,118.063608 C134.385952,119.353741 131.130465,120 127.749811,120 C119.014924,120 111.171782,115.696452 104.274381,107.191543 C103.908541,106.74044 103.908539,106.099034 104.274378,105.64793 C105.541087,104.085987 106.839066,102.666066 108.168648,101.388448 C109.299761,100.301544 110.453852,99.3175278 111.631059,98.4367173 C112.987854,97.4215359 114.432131,96.4710498 115.754745,95.7358124 L108.35903,88.1476505 C107.880323,87.6563457 107.880323,86.8597833 108.35903,86.3684786 Z M117.232773,97.7495373 C115.956875,98.4382022 114.5021,99.3862152 113.140679,100.404858 C112.046913,101.223236 110.970632,102.140909 109.911972,103.158192 C108.879138,104.15066 107.863223,105.237799 106.864428,106.419753 C113.14937,113.857969 120.094882,117.530861 127.749811,117.530861 C130.444121,117.530861 133.044027,117.077098 135.555977,116.167929 L132.847155,113.445034 C131.463866,114.426039 129.807828,114.996008 128.055165,115.056457 C123.225656,115.223027 119.173847,111.491266 119.005197,106.721335 C118.934675,104.726777 119.557127,102.815263 120.727846,101.262767 L117.232773,97.7495373 Z M127.194204,92 C135.949667,92 143.811297,96.404156 150.724971,105.107893 C151.091676,105.569544 151.091676,106.225948 150.724971,106.687599 C148.085394,110.010606 145.309894,112.706099 142.395908,114.770294 C141.829681,115.171395 141.048208,115.033689 140.650438,114.462719 C140.252669,113.89175 140.389231,113.103731 140.955458,112.70263 C143.435364,110.945927 145.827138,108.678591 148.128816,105.897724 C141.829047,98.2856187 134.867162,94.5268629 127.194204,94.5268629 C125.373293,94.5268629 123.803673,94.6555885 122.488859,94.9095255 C121.809235,95.040785 121.152768,94.5916326 121.022598,93.9063157 C120.892429,93.2209987 121.337851,92.5590326 122.017475,92.4277731 C123.500132,92.1414197 125.224537,92 127.194204,92 Z M121.503654,106.635163 C121.624118,110.042257 124.518267,112.7078 127.967917,112.588822 C129.136831,112.548506 130.242679,112.192566 131.187568,111.576425 L122.664536,102.829974 C121.872534,103.921782 121.454638,105.24885 121.503654,106.635163 Z",
  id: "Combined-Shape",
  fill: "#959595",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M55.3814371,113.660439 C55.8250183,113.146448 56.6023414,113.085895 57.1191487,113.528068 C57.6359559,113.97165 57.6936919,114.750381 57.2501107,115.26578 L57.2501107,115.26578 L53.2423902,119.926903 C53.0072218,120.200092 52.6664388,120.356402 52.3073493,120.356402 L52.3073493,120.356402 C51.9454434,120.354994 51.6046604,120.197276 51.3709002,119.924086 L51.3709002,119.924086 L48.2939959,116.320517 C47.8532312,115.802302 47.9151917,115.024979 48.431999,114.582806 C48.9488062,114.140633 49.7275376,114.202593 50.1683024,114.719401 L50.1683024,114.719401 L52.3101657,117.230211 Z M87.7225728,115.848772 C88.6477614,115.848772 89.397775,116.598786 89.397775,117.523975 L89.397775,117.694056 C89.397775,118.619244 88.6477614,119.369258 87.7225728,119.369258 L64.5848453,119.369258 C63.6596566,119.369258 62.909643,118.619244 62.909643,117.694056 L62.909643,117.523975 C62.909643,116.598786 63.6596566,115.848772 64.5848453,115.848772 L87.7225728,115.848772 Z M49.0670945,102.525848 C49.5472887,102.044245 50.3274283,102.044245 50.8090307,102.525848 L50.8090307,102.525848 L52.5340685,104.249477 L54.2605146,102.527256 C54.7407088,102.045653 55.5208483,102.047061 56.0024507,102.527256 C56.4840531,103.00745 56.4840531,103.788998 56.0024507,104.269192 L56.0024507,104.269192 L54.2788211,105.992822 L56.0024507,107.717859 C56.4840531,108.198054 56.4840531,108.978193 56.0024507,109.459796 C55.7630577,109.700597 55.4476222,109.820293 55.1321867,109.820293 C54.8167512,109.820293 54.5013158,109.700597 54.2605146,109.459796 L54.2605146,109.459796 L52.5368849,107.734758 L50.8118471,109.459796 C50.5710459,109.700597 50.2556104,109.820293 49.9401749,109.820293 C49.6247394,109.820293 49.3093039,109.700597 49.0685027,109.459796 C48.5869003,108.978193 48.5869003,108.198054 49.0685027,107.716451 L49.0685027,107.716451 L50.7907242,105.991413 L49.0670945,104.267784 C48.5854921,103.787589 48.5854921,103.00745 49.0670945,102.525848 Z M87.7225728,104.232579 C88.6477614,104.232579 89.397775,104.982592 89.397775,105.907781 L89.397775,106.077862 C89.397775,107.003051 88.6477614,107.753064 87.7225728,107.753064 L64.5848453,107.753064 C63.6596566,107.753064 62.909643,107.003051 62.909643,106.077862 L62.909643,105.907781 C62.909643,104.982592 63.6596566,104.232579 64.5848453,104.232579 L87.7225728,104.232579 Z M55.3814371,90.4280516 C55.8250183,89.9126525 56.6023414,89.8549165 57.1191487,90.2970895 C57.6359559,90.7406707 57.6936919,91.5179938 57.2501107,92.0348011 L57.2501107,92.0348011 L53.2423902,96.6959237 C53.0072218,96.9677052 52.6664388,97.1240147 52.3073493,97.1240147 L52.3073493,97.1240147 C51.9454434,97.1240147 51.6046604,96.9648888 51.3709002,96.6916991 L51.3709002,96.6916991 L48.2939959,93.0881303 C47.8532312,92.5699149 47.9151917,91.7925917 48.431999,91.3504187 C48.9502144,90.909654 49.7275376,90.9716145 50.1697105,91.4884218 L50.1697105,91.4884218 L52.3115738,93.9978237 Z M87.7225728,92.6163853 C88.6477614,92.6163853 89.397775,93.3663989 89.397775,94.2915875 L89.397775,94.4616684 C89.397775,95.3868571 88.6477614,96.1368706 87.7225728,96.1368706 L64.5848453,96.1368706 C63.6596566,96.1368706 62.909643,95.3868571 62.909643,94.4616684 L62.909643,94.2915875 C62.909643,93.3663989 63.6596566,92.6163853 64.5848453,92.6163853 L87.7225728,92.6163853 Z",
  id: "Combined-Shape",
  fill: "#959595",
  fillRule: "nonzero"
})))));

var SvgAutomaticAttendanceNonVisible = function SvgAutomaticAttendanceNonVisible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "129px",
    height: "59px",
    viewBox: "0 0 129 59",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAutomaticAttendanceNonVisible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/automatic-attendance-non-visible.4aa7a76b.svg";
export { ForwardRef as ReactComponent };